import { render, staticRenderFns } from "./PdpBuyingZoneCmsLink.vue?vue&type=template&id=14e27447&"
import script from "./PdpBuyingZoneCmsLink.vue?vue&type=script&lang=js&"
export * from "./PdpBuyingZoneCmsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports